import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@/plugins'
import '@/components'
import '@/components/Tools'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  ...App
}).$mount('#app')
